import axios from 'axios';
import { IMyOwnTractorDetail, IMyOwnTractorImage } from '../../../interfaces/OwnTractor.interfaces';
import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from './getMyOwnTractors';

interface IGetMyOwnTractorImagesByIdParams {
  ownTractorId: string;
}

export const getMyOwnTractorImagesById = ({
  ownTractorId,
}: IGetMyOwnTractorImagesByIdParams): Promise<IMyOwnTractorImage[]> => {
  return customAxios.get(`${myOwnTractorsApiUrl}/${ownTractorId}/images`);
};
